import { render, staticRenderFns } from "./NumberSpinner.vue?vue&type=template&id=aef8e024&"
import script from "./NumberSpinner.vue?vue&type=script&lang=ts&"
export * from "./NumberSpinner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports